export default __webpack_public_path__ + "static/media/WAS0050.34I-35299_-20458_0.51be2bb1.jpg";